<template>
  <div class="footer">
    <div class="links">
      <a href="https://sixfab.com/privacy/">Privacy Policy</a>
      <a href="https://sixfab.com/terms/">Terms of Use</a>
      <button type="button" class="privacy-link" @click="openPrivacy">Privacy preferences</button>
    </div>
    <div class="copyright">
      Copyright © {{ currentYear }} Sixfab. All rights reserved.
    </div>
  </div>
</template>

<script>
import {openConsentPreferences} from "../services/consent";

export default {
  methods: {
    openPrivacy() {
      openConsentPreferences();
    },
  },
  data() {
    return {
      currentYear: new Date().getFullYear(),
    };
  },
};
</script>

<style scoped>
.footer {
  display: flex;
  flex-direction: row;
  height: 51px;
  padding: 0px 24px;
  align-items: center;
  background: #fff;
  justify-content: space-between;
}

.links {
  display: flex;
  flex-direction: row;
  gap: 24px;
}
.links a,
.links a:visited,
.links a:hover,
.links a:active {
  color: #000;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;

  text-decoration: none;
  cursor: pointer;
}

.privacy-link {
  border: 0; padding: 0; background: transparent; color: #000;
  font-family: Inter; font-size: 12px; cursor: pointer;
}
.privacy-link:hover { text-decoration: underline; }
.privacy-link:focus-visible { outline: 2px solid #429cbf; outline-offset: 4px; }

.copyright {
  color: #000;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
@media (max-width: 760px) {
  .footer { height: auto; min-height: 51px; padding: 14px 20px; flex-direction: column; gap: 12px; }
  .links { flex-wrap: wrap; justify-content: center; gap: 12px 18px; }
  .copyright { text-align: center; }
}
</style>
